module.exports = __webpack_public_path__ + "static/ficosec-2-33eb2adddea0f3a29673e4c11a6a0ad9.jpg";